import { getThemeFromRoute, SiteTheme } from "@features/header/header-theme"
import { cn } from "@utils/tw"
import { SingleContentBlock } from "eddev/blocks"
import { useAppData } from "eddev/hooks"
import { RouteDisplay, RouteState } from "eddev/routing"
import { useEffect, useMemo } from "react"

export function ThemedRouteDisplay(props: { route: RouteState; isMain?: boolean; className?: string }) {
  const footer = useAppData((d) => d.templateParts?.siteFooter?.contentBlocks[0]!)
  const theme = useMemo(() => {
    return getThemeFromRoute(props.route)
  }, [props.route])

  useEffect(() => {
    if (props.isMain) {
      if (theme.page === "dark") {
        document.documentElement.classList.add("theme-dark", "bg-bg")
      } else {
        document.documentElement.classList.remove("theme-dark", "bg-bg")
      }
    }
  }, [theme.page])

  return (
    <div
      className={cn(
        "page-content transition-colors bg-bg text-fg",
        theme.page === "dark" ? "theme-dark" : "theme-light",
        props.className,
      )}
    >
      <SiteTheme route={props.route}>
        <RouteDisplay route={props.route} />
        <SingleContentBlock block={footer} />
      </SiteTheme>
    </div>
  )
}
